export class Institution {
    public _id: string;   
    public institutionName:string;
    public created:Date;
}